import React from "react";

import * as S from "./styles";

import { useQuery } from "react-query";
import { fetchInventoryTransfers } from "api/transfer";
import { getColumns } from "pages/fulfillment/InventoryTransferIndexPage/helper";
import Table from "../Table";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useHistory } from "react-router";

interface InventoryTransferTableProps {
  query: { organization_id?: string; per_page?: number };
}

const InventoryTransferTable: React.FC<InventoryTransferTableProps> = ({ query }) => {
  const history = useHistory();
  const orgId = query.organization_id;
  const { data: transfers, ...transfersQuery } = useQuery(
    ["transfers", orgId],
    () =>
      fetchInventoryTransfers({
        organization_id: orgId,
      }),
    { enabled: !!orgId }
  );
  const goToCreateTransferPage = () => {
    history.push(`/organizations/${orgId}/transfers/create`);
  };

  const tableProps = {
    columns: getColumns(orgId || ""),
    dataSource: transfers?.data || [],
    loading: transfersQuery?.isLoading,
  };

  const headerButtons = (
    <Button onClick={goToCreateTransferPage} icon={<PlusOutlined />}>
      Create Transfer
    </Button>
  );

  return (
    <div className="fulfillment-table" id="inventory-transfer-table">
      <S.StyledTable>
        <Table
          headerButtons={headerButtons}
          tableProps={tableProps}
          title="Inventory Transfers"
          fullListLink={orgId ? `/organizations/${orgId}/transfers` : null}
        />
      </S.StyledTable>
    </div>
  );
};

export default InventoryTransferTable;
